module.exports = __webpack_public_path__ + "static/media/track-BG-2nd-layer-two@2x.7bd251ef.png";